import { Switch } from '@clientbase/clientbase-library'
import { Box, Stack, Typography } from '@mui/material'
import InvoiceIcon from 'templates/Invoice/components/InvoiceIcon'

import { theme } from 'styles/theme'

interface EmitNfseOnReceiptSwitchProps {
  checked: boolean
  onChange: (checked: boolean) => void
}

/**
 * Opção "Emitir nota fiscal" das telas de registrar recebimento. A emissão em si
 * acontece depois do recebimento registrado, no modal de nota fiscal.
 */
const EmitNfseOnReceiptSwitch = ({
  checked,
  onChange
}: EmitNfseOnReceiptSwitchProps) => (
  <Stack
    direction="row"
    alignItems="center"
    justifyContent="space-between"
    gap={2}
    p={1.5}
    border={`1px solid ${theme.palette.neutral[700]}`}
    borderRadius="8px"
  >
    <Stack direction="row" alignItems="center" gap={1.5}>
      <Box display="inline-flex" flexShrink={0}>
        <InvoiceIcon width={20} color="#3F403F" />
      </Box>
      <Stack>
        <Typography variant="smBold">Emitir nota fiscal</Typography>
        <Typography variant="smLight" color={theme.palette.neutral[400]}>
          Ao registrar, você confere os dados e emite a nota já vinculada a este
          recebimento.
        </Typography>
      </Stack>
    </Stack>
    <Switch
      value={checked}
      checked={checked}
      onChange={(_: unknown, value: boolean) => onChange(value)}
      inputProps={{ 'aria-label': 'Emitir nota fiscal' }}
    />
  </Stack>
)

export default EmitNfseOnReceiptSwitch
